module.exports = require("oauth");